import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  const {type, appbar, getContrastText} = theme.palette;
  return {
    container: {
      display: "flex",
      flexFlow: "row nowrap",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "15px"
    },
    languageIcon: {
      cursor: "pointer",
      borderRadius: "5px",
      padding: theme.spacing(0.5),
      color: getContrastText(appbar[type]),
      "&:hover": {
        background: theme.palette.action.hover
      }
    },
    flags: {
      width: 20
    }
  }
});
